import { render, staticRenderFns } from "./PadraoDirecao.vue?vue&type=template&id=f5f8934a&scoped=true"
import script from "./PadraoDirecao.vue?vue&type=script&lang=js"
export * from "./PadraoDirecao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f8934a",
  null
  
)

export default component.exports